import React from 'react';
import { User } from 'lucide-react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const ClientSection = ({ customer }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '6mm'
      }}
    >
      <User size={20} color={COLORS.primary} strokeWidth={2} />
      <span style={{ ...TYPOGRAPHY.sectionTitle, color: COLORS.textPrimary, whiteSpace: 'nowrap' }}>
        DADOS DO CLIENTE:
      </span>
      <span
        style={{
          flex: 1,
          borderBottom: `1px solid ${COLORS.line}`,
          fontSize: '12px',
          color: COLORS.textPrimary,
          paddingBottom: '3px',
          paddingLeft: '8px'
        }}
      >
        {customer ? `${customer.name || ''} ${customer.phone ? `• ${customer.phone}` : ''} ${customer.email ? `• ${customer.email}` : ''}` : '_______________________________________________________________'}
      </span>
    </div>
  );
};

export default ClientSection;
